import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

export const tableHeader = tv({
  slots: {
    row: 'flex flex-row gap-4 p-5 md:gap-8',
    column: 'flex flex-1 flex-col items-center gap-y-2.5',
    emptyColumn: 'hidden w-[375px] md:block',
    text: caption({ align: 'center' }),
    firstDummyColumn: 'hidden flex-col gap-y-2.5 pb-6 md:flex md:w-[375px]',
  },
})
